import type { WebsiteHeaderPhotoSchema_PhotoTrio } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_TRIO_DEFAULT: WebsiteHeaderPhotoSchema_PhotoTrio = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoTrio-v1_1_1.json',
  presentationLayout: 'photoTrio',
  photos: [],
};
